/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import { getCalloutClass } from '../../lib/helpers';

type Props = {
  systemMessage: ISystemMessage;
}

const CalloutComponent: FC<Props> = ({
  systemMessage,
}) => (
  <aside key={systemMessage.id} className={`header-callout${getCalloutClass(systemMessage.severity)}`} aria-labelledby={`system-message-${systemMessage.id}`}>
    <div className="header-callout__content">
      <h1 className="header-callout__title" id={`system-message-${systemMessage.id}`}>{systemMessage.title}</h1>
      <div className="header-callout__message" dangerouslySetInnerHTML={{ __html: systemMessage.message }} />
    </div>
  </aside>
);

CalloutComponent.displayName = 'CalloutComponent';
export default CalloutComponent;
